module.exports = __webpack_public_path__ + "static/github_accent-e98e226e665ee0711761fcedc5c0877c.png";